import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CheckAuth } from 'src/Services/utility.service';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { CRRASubCategorysModel } from 'src/Models/CRRASubCategoryModel';
import { CrraSubCategoryMasterService } from 'src/Services/crra-sub-category-master.service';
import { CrraCategoryMasterService } from 'src/Services/crra-category-master.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-crra-sub-category',
  templateUrl: './crra-sub-category.component.html',
  styleUrls: ['./crra-sub-category.component.css']
})
export class CrraSubCategoryComponent implements OnInit {

  stateCode: any;
  tokenKey: string;
  listofCategory: CRRASubCategorysModel[];
  listofCategoryExport: CRRASubCategorysModel[];

  PageNumber: number = 1;
  PageSize: number;
  WhereCondition: string;
  OrderBy: string;
  subcategoryName: string;

  upDowCategoryNameCSS: string = '';
  upDowCategorySortCSS: string = '';
  upDowActiveCSS: string = '';
  upDowSubCategoryNameCSS :string = '';
  isAscending: boolean = false;
  isRecord: boolean = false;
  isloading: boolean = false;
  SelectedTool: string;
  totalRecordCount: number = 0;
  isState911: boolean = false;
  subCategoryId: number = 0;

  categoryListMain: any[] = [];
  dropdownDateCategoryFilterMain: any[] = [];
  dropdownSettingsDateCategoryFilterMain = {};
  selectedItemsCategoryMain = [];
  listOfCategoryIDsMain = [];
  categoryId: string = '';
  openMenuIndex: number = -1;

  constructor(private readonly router: Router,
    private readonly crraSubCategoryMaster: CrraSubCategoryMasterService,
    private readonly crraCategoryMaster: CrraCategoryMasterService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.listofCategory = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    this.WhereCondition = 'null';
    this.OrderBy = 'SortOrder';
    this.subcategoryName = 'null';
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Sub Categories');

  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.dropdownSettingsDateCategoryFilterMain = {
      singleSelection: false,
      text: "Filter by Category",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Category(s) available',
      showCheckbox: true
    };

    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.isloading = true;
    this.getCategory();
    this.GetSubCategory();
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetSubCategory();
  }

  GetSubCategory() {
    this.isloading = true;
    this.listofCategory = [];
    this.categoryId = ' ';
    if (this.listOfCategoryIDsMain.length > 0) {
      this.categoryId = this.listOfCategoryIDsMain.join(',')
    }
    if (this.subcategoryName == "null") this.subcategoryName = " ";
    this.crraSubCategoryMaster.GetAllSubCategory(this.tokenKey, this.PageNumber, this.PageSize, this.subcategoryName,this.categoryId, this.OrderBy,false).subscribe(
      data => {
        this.isloading = false;
        this.listofCategory = data['crrasubcategory'];
        if (this.listofCategory != null) {
          if (this.listofCategory.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofCategory[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
      error => { this.stateCode = error }
    );

  }

  keywordFilters($event) {
    this.PageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.subcategoryName = $event.target.value;
    else
      this.subcategoryName = 'null';

    this.GetSubCategory();
  }

  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';

      if (sortBy === "SubcategoryName") {
        this.upDowSubCategoryNameCSS = 'fa fa-arrow-down';
        this.upDowCategoryNameCSS = '';
        this.upDowCategorySortCSS = '';
      }
      else if (sortBy === "categoryName") {
        this.upDowSubCategoryNameCSS = '';
        this.upDowCategoryNameCSS = 'fa fa-arrow-down';
        this.upDowCategorySortCSS = '';
      }
      else if (sortBy === "SortOrder") {
        this.upDowSubCategoryNameCSS = '';
        this.upDowCategoryNameCSS = '';
        this.upDowCategorySortCSS = 'fa fa-arrow-down';
      }
      
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "SubcategoryName") {
        this.upDowSubCategoryNameCSS = 'fa fa-arrow-up';
        this.upDowCategoryNameCSS = '';
        this.upDowCategorySortCSS = '';
      }
      else if (sortBy === "categoryName") {
        this.upDowSubCategoryNameCSS = '';
        this.upDowCategoryNameCSS = 'fa fa-arrow-up';
        this.upDowCategorySortCSS = '';
      }
      else if (sortBy === "SortOrder") {
        this.upDowSubCategoryNameCSS = '';
        this.upDowCategoryNameCSS = '';
        this.upDowCategorySortCSS = 'fa fa-arrow-up';
      }
      
    }
    this.PageNumber = 1;
    this.GetSubCategory();
  }

  addCategory() {
    let navigation = '/admin/' + this.SelectedTool + '/subCategory/manage';
    this.router.navigate([navigation]);
  }

  updateCategory(subCategoryId) {
    let navigation = '/admin/' + this.SelectedTool + '/subCategory/manage/' + subCategoryId;
    this.router.navigate([navigation]);
  }

  setDeleteData(id) {
    this.subCategoryId = id;
  }

  deleteCategory(subCategoryId) {
    this.isloading = true;
    this.crraSubCategoryMaster.DeleteSubCategory(this.tokenKey, subCategoryId).subscribe(
      data => {
        this.isloading = false;
        if (data['status'] == 'Success') {
          if (data['message'] != "")
            this.showMessage(data['message'], 'Warning', 'warning')
          else
          this.showMessage("Sub Category Deleted successfully", 'Success', 'success')
        }
        this.GetSubCategory();
      },
      error => { this.stateCode = error }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  getCategory() {
    this.crraCategoryMaster.GetCategory(this.tokenKey).subscribe(
      result => {
        if (result['status'] == 'Success') {

          this.categoryListMain = result['crracategory'];
          this.dropdownDateCategoryFilterMain = [];
          this.categoryListMain.forEach(x => {
            this.dropdownDateCategoryFilterMain.push({ "id": x.categoryId, "itemName": x.categoryName })
          });

          if (this.listOfCategoryIDsMain != null && this.listOfCategoryIDsMain != undefined) {
            for (let iCounter = 0; iCounter < this.listOfCategoryIDsMain.length; iCounter++) {
              if (this.listOfCategoryIDsMain[iCounter] != '') {
                let obj = result["crracategory"].filter(m => m.categoryId == this.listOfCategoryIDsMain[iCounter]);
                if (obj != null) {
                  this.selectedItemsCategoryMain.push({ "id": obj[0].categoryId, "itemName": obj[0].categoryName });
                }
              }
            }
          }

        }
      },
      error => { }
    );
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  onSelectCategoryMain($event) {
    this.listOfCategoryIDsMain = this.removeElemetninArray(this.listOfCategoryIDsMain, $event.id)
    this.listOfCategoryIDsMain.push($event.id);
    this.resetPageNoandSize();
    this.GetSubCategory();
  }

  onDeSelectCategoryMain($event) {
    if (this.listOfCategoryIDsMain != null) {
      if (this.listOfCategoryIDsMain.length > 0) {
        this.listOfCategoryIDsMain = this.removeElemetninArray(this.listOfCategoryIDsMain, $event.id)
      }
    }
    this.resetPageNoandSize();
    this.GetSubCategory();
  }

  onSelectAllCategoryMain($event) {
     for (const item of $event) {
      if (this.listOfCategoryIDsMain != null) {
        if (this.listOfCategoryIDsMain.length > 0) {
          this.listOfCategoryIDsMain = this.removeElemetninArray(this.listOfCategoryIDsMain, item.id)
          this.listOfCategoryIDsMain.push(item.id);
        }
        else {
          this.listOfCategoryIDsMain.push(item.id);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetSubCategory();
  }

  onDeSelectAllCategoryMain($event) {

    this.listOfCategoryIDsMain = [];
    this.resetPageNoandSize();
    this.GetSubCategory();
  }

  resetPageNoandSize() {
    this.PageNumber = 1;
    this.PageSize = 10;
  }

  onFilterSelectAll($event){
     for (const item of $event) {
      if (this.listOfCategoryIDsMain != null) {
        if (this.listOfCategoryIDsMain.length > 0) {
          this.listOfCategoryIDsMain = this.removeElemetninArray(this.listOfCategoryIDsMain, item.id)
          this.listOfCategoryIDsMain.push(item.id);
        }
        else {
          this.listOfCategoryIDsMain.push(item.id);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetSubCategory();
  }

  onFilterDeSelectAll($event){
     for (const item of $event) {
      if (this.listOfCategoryIDsMain != null) {
        if (this.listOfCategoryIDsMain.length > 0) {
          this.listOfCategoryIDsMain = this.removeElemetninArray(this.listOfCategoryIDsMain, item.id)
        }
      }
    }
    this.resetPageNoandSize();
    this.GetSubCategory();
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportCRRASubCategories() {
    this.isloading = true;
    this.listofCategoryExport=[];
    this.categoryId = ' ';
    if (this.listOfCategoryIDsMain.length > 0) {
      this.categoryId = this.listOfCategoryIDsMain.join(',')
    }
    if (this.subcategoryName == "null") this.subcategoryName = " ";
    this.crraSubCategoryMaster.GetAllSubCategory(this.tokenKey, this.PageNumber, this.PageSize, this.subcategoryName,this.categoryId, this.OrderBy,true).subscribe(
      data => {
        this.listofCategoryExport = data['crrasubcategory'];
        if (this.listofCategoryExport != null) {
          if (this.listofCategoryExport.length > 0)
          {
            setTimeout(() => {
              this.DownloadCRRASubCategories();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else
        {
          this.isloading = false;
            this.toastr.error("No record found", "Error");
        }
      },
      error => { 
        this.isloading = false;
        console.log(error);
       }
    );
  }

  DownloadCRRASubCategories() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportCRRASubCategories';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportCRRASubCategories.xls");
  }

}
